export default{
	contactsUs:{
		mr:'Mr. Li',
		contacts:'contacts',
		contact:'Contact Us',
		submitBtn:'submit',
		userName:'name',
		tel:'telphoneNumber',
		email:'e-mail',
		remark:'remark',
		company:'companyName',
		welcome:'People from all walks of life are welcomed to come and negotiate cooperation.',
		message:'A message or an email may be just the beginning of creating a great product. Tell us your needs, and we will reply quickly and accurately. We will contact you through the contact information you left within 30 minutes and provide a quotation.'
	},
	portfolio:{
		productsTitle1:'Smart Finance',
		productsTitle2:'Smart Healthcare',
		productsTitle3:'Smart Meteorology ',
		productsTitle4:'Smart Transportation',
		productsTitle5:'Smart E-commerce',
		productsTitle6:'Smart City',
	},
	serve:{
		business:'Serve Business',
		title1:'Enterprise product customization.',
		title2:'External investment in Internet projects.',
		title3:'Technology team cooperation strategy.',
		title4:'Research and development, and design of Internet products.',
		title5:'Output of Internet talents and teams.',
		title6:'Enterprises cultivate talents in a targeted manner.'
	},
	serviceProcess:{
		process:'Service Process',
		service:'Mobile Internet consultants, one-stop services.'
	},
	company:{
		service:'APP • Mini Program • PC System • PC Website  • WeChat Official Account Development',
		tips:'The most professional provider of enterprise mobile solutions.'
	},
	appName:'ChengduMaizhiyaTechnology Co., Ltd.',
	detail:'Detail',
	view:'View',
	language:'中文'
	
}